import { createClient as createSupabaseClient } from '@supabase/supabase-js'
import { Database } from './types'

declare global {
  interface Window {
    __ENV?: Record<string, string | undefined>
  }
}

// Preferir runtime env (Portainer/Compose) e cair para Vite env em dev/build.
// Importante: se runtime vier como string vazia (''), tratamos como ausente.
const runtimeSupabaseUrl = window?.__ENV?.VITE_SUPABASE_URL
const runtimeSupabaseAnonKey = window?.__ENV?.VITE_SUPABASE_ANON_KEY

const supabaseUrl = runtimeSupabaseUrl ? runtimeSupabaseUrl : import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = runtimeSupabaseAnonKey ? runtimeSupabaseAnonKey : import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables')
  console.error('Supabase URL:', supabaseUrl ? '✓' : '✗')
  console.error('Supabase Key:', supabaseAnonKey ? '✓' : '✗')
  throw new Error(
    'Missing Supabase environment variables. Please check your .env file.\n' +
    'Required: VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY'
  )
}

// Instância singleton do cliente Supabase
let supabaseInstance: ReturnType<typeof createSupabaseClient<Database>> | null = null

export const createClient = () => {
  // Retorna sempre a mesma instância (singleton)
  if (!supabaseInstance) {
    supabaseInstance = createSupabaseClient<Database>(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storage: window.localStorage,
      },
      global: {
        headers: {
          'X-Client-Info': 'solis-orcamento-web',
        },
      },
    })
  }
  return supabaseInstance
}

// Exporta a instância singleton
export const supabase = createClient() 